import { Navigate, Outlet } from "react-router-dom";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import type { OrgFeatures } from "models";

interface FeatureFlagRouteProps {
  flag: keyof OrgFeatures;
}

const FeatureFlagRoute = ({ flag }: FeatureFlagRouteProps) => {
  const enabled = useFeatureFlag(flag);
  return enabled ? <Outlet /> : <Navigate to="/" />;
};

export default FeatureFlagRoute;
